import { render, staticRenderFns } from "./VerticalNavMenuGroup.vue?vue&type=template&id=11a9637a&"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=ts&"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=ts&"
import style0 from "./verticalNavMenuGroup.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./VerticalNavMenuGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports